export const trophies = {
  trophy: require('@Assets/images/trophies/trophy.png'),
  april2022: require('@Assets/images/trophies/april.png'),
  zevent2022: require('@Assets/images/trophies/zevent2022.png'),
};
